/**
 * Tree data helpers for the cockpit grid.
 *
 * MUI X throws (and the page goes blank) as soon as two rows share the same
 * tree data path, so every path built here must be unique.
 */

export const UNKNOWN_REGION_LABEL = 'Unknown';

/**
 * Region names coming from BigQuery can be empty when a country is not mapped.
 * An empty name would make a child row collapse onto its parent's path.
 */
export function normalizeRegionName(name: unknown): string {
    return (typeof name === 'string' ? name.trim() : '') || UNKNOWN_REGION_LABEL;
}

export function getCockpitTreeDataPath(row: any): string[] {
    if (!row.parentId) {
        return [String(row.id)];
    }

    return [
        String(row.parentId),
        normalizeRegionName(row.country),
    ];
}